import ajax from './axios'

// 车辆列表
export const vehicleList = params => {
  return ajax.get('/user/car/wx/list', params)
}
// 原厂技术参数查询
export const factoryParams = params => {
  return ajax.get(`/garage/car/factory-params?carModelId=${params.carModelId}&vendor=${params.vendor}`)
}